import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import logger from 'utils/logger.util';
import actionType from 'utils/mw/actionType.util';
import isFn from 'utils/predicates/function/isFn.util';

const L = logger('actionFe');

const actionFe = (ATAG, dataFn, actionFn) => {
  const AT = actionType(ATAG);
  const type = fromAnyToTrimmed(AT.name);

  if (!type) L.error('()', 'Invalid action type:', type);

  return Object.assign(
    (data) => {
      const d = isFn(dataFn) ? dataFn(data) : data;
      const action = { AT, ATAG, L: logger(ATAG), type, data: d };
      return isFn(actionFn) ? actionFn(action) : action;
    },
    { AT, ATAG },
  );
};

// noinspection JSUnusedGlobalSymbols
export default actionFe;
